import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Logo() {
	const classes = useStyles();

	return (
		<svg width="46px" height="21px" viewBox="0 0 46 21" className={classes.title}>
			<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="Group" transform="translate(-1.000000, 0.000000)">
					<text id="Bkeys" font-family="Helvetica-Bold, Helvetica" font-size="16" font-weight="bold" fill="#3852FF">
						<tspan x="0.42578125" y="17">
							Bkeys
						</tspan>
					</text>
					<circle id="Oval" stroke="#3852FF" stroke-width="2" cx="14" cy="3" r="2"></circle>
				</g>
			</g>
		</svg>
	);
}
